// Mapping FR ↔ EN pour les routes du site.
// Source de vérité unique : permet au LanguageSwitcher de basculer une URL en gardant le contexte de page,
// et à localizedPath() de générer les bons liens internes selon la langue active.

export type Lang = "fr" | "en";

// Routes statiques : chaque entrée associe le chemin FR à son équivalent EN.
// Les routes dynamiques (slugs établissements, blog, villes SEO) sont préfixées via le helper localizedPath.
export const ROUTE_MAP: Record<string, string> = {
  "/": "/en",
  "/reserver": "/en/book",
  "/etablissements": "/en/locations",
  "/livraison": "/en/delivery",
  "/experiences": "/en/experiences",
  "/professionnels": "/en/professionals",
  "/a-propos": "/en/about",
  "/faq": "/en/faq",
  "/contact": "/en/contact",
  
  "/formule-location-velo-landes": "/en/bike-rental-package",
  "/location-surf-contis": "/en/surf-rental-contis",
  "/mentions-legales": "/en/legal-notice",
  "/politique-de-confidentialite": "/en/privacy-policy",
  "/cgv": "/en/terms",
  "/plan-du-site": "/en/sitemap",

  // SEO town pages — FR /location-velo-{slug} ↔ EN /en/{slug}-bike-rental
  "/location-velo-mimizan": "/en/mimizan-bike-rental",
  "/location-velo-lit-et-mixe": "/en/lit-et-mixe-bike-rental",
  "/location-velo-bias": "/en/bias-bike-rental",
  "/location-velo-leon": "/en/leon-bike-rental",
  "/location-velo-moliets-et-maa": "/en/moliets-et-maa-bike-rental",
  "/location-velo-azur": "/en/azur-bike-rental",
  "/location-velo-castets": "/en/castets-bike-rental",
  "/location-velo-levignacq": "/en/levignacq-bike-rental",
  "/location-velo-saint-girons-plage": "/en/saint-girons-plage-bike-rental",
  "/location-velo-taller": "/en/taller-bike-rental",
  "/location-velo-saint-michel-escalus": "/en/saint-michel-escalus-bike-rental",
  "/location-velo-onesse-laharie": "/en/onesse-laharie-bike-rental",
};

// Inverse mapping pour passer de EN vers FR
export const ROUTE_MAP_INVERSE: Record<string, string> = Object.fromEntries(
  Object.entries(ROUTE_MAP).map(([fr, en]) => [en, fr]),
);

/** Convertit le path courant vers son équivalent dans la langue cible. */
export function translateRoute(currentPath: string, targetLang: Lang): string {
  // Normalise sans trailing slash (sauf racine)
  const path = currentPath.length > 1 && currentPath.endsWith("/") ? currentPath.slice(0, -1) : currentPath;

  if (targetLang === "en") {
    if (path.startsWith("/en")) return path; // déjà EN
    if (ROUTE_MAP[path]) return ROUTE_MAP[path];
    // Routes dynamiques (slug étab., blog, ville SEO) → préfixer /en
    return `/en${path}`;
  }
  // target = fr
  if (!path.startsWith("/en")) return path;
  if (ROUTE_MAP_INVERSE[path]) return ROUTE_MAP_INVERSE[path];
  // /en/quelque-chose → /quelque-chose
  const stripped = path.replace(/^\/en/, "") || "/";
  return stripped;
}

/** Détecte la langue active depuis le pathname. */
export function detectLangFromPath(pathname: string): Lang {
  return pathname === "/en" || pathname.startsWith("/en/") ? "en" : "fr";
}
